import PopoverContainer from "../../../Components/UiKits/Popover/PopoverContainer";

const Popover = () => {
  return <PopoverContainer />;
};

export default Popover;
